var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleIllustration = function SvgGoogleIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 66 63"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#googleIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.387,
    cy: 30.628,
    fill: "#fff",
    rx: 28.913,
    ry: 27.628
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.233 15.817a16.069 16.069 0 0 0 1.1 30.699c2.691.694 5.51.724 8.217.088a14.5 14.5 0 0 0 6.576-3.417 14.6 14.6 0 0 0 4.063-6.668c.786-2.774.926-5.69.409-8.527H32.484v6.27h8.753a7.55 7.55 0 0 1-3.215 4.956 9.2 9.2 0 0 1-3.537 1.396 10.5 10.5 0 0 1-3.834 0 9.45 9.45 0 0 1-3.567-1.556 9.98 9.98 0 0 1-3.682-4.931 9.73 9.73 0 0 1 0-6.254 10 10 0 0 1 2.33-3.786 9.44 9.44 0 0 1 9.51-2.483 8.7 8.7 0 0 1 3.463 2.03q1.481-1.47 2.956-2.952c.508-.53 1.061-1.036 1.562-1.58a15.5 15.5 0 0 0-5.17-3.189 16.25 16.25 0 0 0-10.82-.096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E33629",
    d: "M27.233 15.81a16.25 16.25 0 0 1 10.82.094 15.5 15.5 0 0 1 5.166 3.205c-.508.543-1.043 1.05-1.561 1.579q-1.478 1.476-2.953 2.94a8.7 8.7 0 0 0-3.464-2.031 9.44 9.44 0 0 0-9.511 2.473 10 10 0 0 0-2.332 3.786l-5.263-4.075a16.13 16.13 0 0 1 9.098-7.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BD00",
    d: "M16.739 27.819c.283-1.403.752-2.76 1.396-4.038l5.264 4.086a9.73 9.73 0 0 0 0 6.254 1537 1537 0 0 0-5.264 4.083 16.08 16.08 0 0 1-1.396-10.385"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#587DBD",
    d: "M32.484 27.984h15.113a18.9 18.9 0 0 1-.409 8.527 14.6 14.6 0 0 1-4.063 6.668c-1.698-1.326-3.405-2.64-5.103-3.966a7.55 7.55 0 0 0 3.214-4.962h-8.752c-.003-2.087 0-4.177 0-6.267"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#319F43",
    d: "M18.133 38.2q2.633-2.031 5.264-4.083a9.98 9.98 0 0 0 3.686 4.931 9.45 9.45 0 0 0 3.576 1.544c1.267.236 2.567.236 3.834 0a9.2 9.2 0 0 0 3.537-1.396c1.699 1.325 3.405 2.64 5.104 3.966a14.5 14.5 0 0 1-6.577 3.42 17.2 17.2 0 0 1-8.217-.089 16 16 0 0 1-5.84-2.943 16.2 16.2 0 0 1-4.367-5.35"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "googleIllustration_svg__a",
    width: 64.249,
    height: 61.68,
    x: 0.905,
    y: 0.43,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.642,
    dy: 0.642
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.606
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420_1161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_420_1161",
    result: "shape"
  })))));
};
export default SvgGoogleIllustration;